import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onSwiper"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Controller, Navigation, Pagination, Scrollbar, A11y, EffectFade } from "swiper/core";
import { useCallback } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
SwiperCore.use([Autoplay, Controller, Navigation, Pagination, Scrollbar, A11y, EffectFade]);

function SliderCore(_ref) {
  var onSwiper = _ref.onSwiper,
      props = _objectWithoutProperties(_ref, _excluded);

  var children = props.children,
      _props$sliderOptions = props.sliderOptions,
      sliderOptions = _props$sliderOptions === void 0 ? {} : _props$sliderOptions; // 複数行にする場合はslidesPerColumnを指定する

  var handleSwiper = useCallback(function (control) {
    if (onSwiper) {
      onSwiper(control);
    }
  }, [onSwiper]);
  return /*#__PURE__*/_jsx(Swiper, _objectSpread(_objectSpread({}, sliderOptions), {}, {
    onSwiper: handleSwiper,
    children: React.Children.map(children, function (item, i) {
      return /*#__PURE__*/_jsx(SwiperSlide, {
        children: item
      }, "swiper-slide-".concat(i));
    })
  }));
}

export default SliderCore;